import {XIcon} from '@primer/octicons-react'
import {Heading, IconButton} from '@primer/react'
import {memo, useRef} from 'react'
import styles from './DockedSidebar.module.css'
import {useDockedPanel} from '../../contexts/DockedPanelContext'
import type {DockedPanelType} from '../../contexts/DockedPanelContext'

const panelHeadings: Record<Exclude<DockedPanelType, null>, string> = {
  comments: 'Comments',
  alerts: 'Alerts',
  overview: 'Overview',
}

interface DockedSidebarContentProps {
  onClose: () => void
}

export const DockedSidebarContent = memo(function DockedSidebarContent({onClose}: DockedSidebarContentProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null)
  const panelName = useDockedPanel()
  const heading = panelName ? panelHeadings[panelName] : 'Comments'

  // TODO: Remove d-none when wiring up panel https://github.com/github/pull-requests/issues/22567
  // This is just set to d-none to add preliminary tests for docked panel behavior
  return (
    <div className="d-flex flex-column height-full d-none">
      {/* Header */}
      <div className={styles.Header}>
        <div className={styles.HeaderContent}>
          <Heading as="h3" className={styles.Heading}>
            {heading}
          </Heading>
          <IconButton
            ref={closeButtonRef}
            aria-label="Close sidebar"
            icon={XIcon}
            variant="invisible"
            size="medium"
            onClick={onClose}
          />
        </div>
        <div id="docked-side-panel-header" />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto pr-p-3" id="docked-side-panel-body" />

      {/* Footer */}
      <div id="docked-side-panel-footer" />
    </div>
  )
})
